module.exports = __webpack_public_path__ + "img/bb03.2f9ea437.png";